var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 14,
    viewBox: "0 0 3 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35742 4.49023V14H0.230469V4.49023H2.35742ZM0.0898438 1.99414C0.0898438 1.67187 0.195312 1.40527 0.40625 1.19434C0.623047 0.977539 0.921875 0.869141 1.30273 0.869141C1.67773 0.869141 1.97363 0.977539 2.19043 1.19434C2.40723 1.40527 2.51562 1.67187 2.51562 1.99414C2.51562 2.31055 2.40723 2.57422 2.19043 2.78516C1.97363 2.99609 1.67773 3.10156 1.30273 3.10156C0.921875 3.10156 0.623047 2.99609 0.40625 2.78516C0.195312 2.57422 0.0898438 2.31055 0.0898438 1.99414Z",
    fill: "#BF1E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/iIcon.18f69762d1441eb8c01e80050579e1e9.svg";
export { ForwardRef as ReactComponent };